module.exports = __webpack_public_path__ + "static/41-9837e80ec2705d8fac923bb14d0657e7.png";